// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.

// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import classNames from 'classnames';
import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'underscore';

import {TagSchemaItemType} from 'graphql-client/__generated/graphqlGlobalTypes';
import * as browser from 'lib/Browser';
import getTestProps from 'test/lib/cypress/getTestProps';
import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import {FOLDER_ITEM_ICONS_BY_ITEM_TYPE} from 'ui-library/icons/IconConstants';

interface SchemaIconProps {
  icon: BenchlingIconName;
}

function SchemaIcon({icon}: SchemaIconProps): JSX.Element {
  return (
    <BenchlingIcon
      icon={icon}
      ifIconMissingReason="Old client possibly attempting to access new schema icons"
      className="iconPicker-icon"
    />
  );
}

export interface IconPickerProps {
  itemType: TagSchemaItemType | null;
  disabled: boolean;
  value: BenchlingIconName;
  onChange: (icon: BenchlingIconName) => void;
}

interface IconPickerState {
  isBeingEdited: boolean;
  searchQuery: string;
}

class IconPicker extends React.Component<IconPickerProps, IconPickerState> {
  static defaultProps = {
    disabled: false,
  };

  namespace!: string;

  override state: IconPickerState = {
    isBeingEdited: false,
    searchQuery: '',
  };

  override componentDidMount(): void {
    this.namespace = _.uniqueId('iconPicker-');
    if (browser.isBrowser) {
      $('body').on(`mousedown.${this.namespace}`, this.handleBodyMouseDown);
    }
  }

  override componentWillUnmount(): void {
    if (browser.isBrowser) {
      $('body').off(`.${this.namespace}`);
    }
  }

  handleBodyMouseDown = (e: JQueryEventObject): void => {
    if (!$.contains(ReactDOM.findDOMNode(this) as Element, e.target) && this.state.isBeingEdited) {
      this.setState({isBeingEdited: false, searchQuery: ''});
    }
  };

  _toggleOpen = (): void => {
    if (this.state.isBeingEdited) {
      this.setState({isBeingEdited: false, searchQuery: ''});
    } else {
      this.setState({isBeingEdited: true});
    }
  };

  handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    this.setState({searchQuery: e.target.value});
  };

  iconChangeHandler = (icon: BenchlingIconName): void => {
    this.setState({isBeingEdited: false, searchQuery: ''});
    this.props.onChange(icon);
  };

  renderOptions = (): JSX.Element => {
    const icons = this.props.itemType
      ? FOLDER_ITEM_ICONS_BY_ITEM_TYPE[this.props.itemType]
      : FOLDER_ITEM_ICONS_BY_ITEM_TYPE[TagSchemaItemType.BASIC_FOLDER_ITEM];
    const filteredIcons = icons.filter((icon) =>
      icon.toLowerCase().includes(this.state.searchQuery.toLowerCase())
    );
    if (filteredIcons.length === 0) {
      return <div className="iconPicker-emptyState">No matching icons</div>;
    }
    return (
      <table className="iconPicker-iconTable">
        <tbody>
          {filteredIcons.length <= 4 ? (
            <tr>
              {filteredIcons.map((icon: BenchlingIconName) => (
                <td
                  className="iconPicker-iconCell"
                  key={icon}
                  onClick={this.iconChangeHandler.bind(this, icon)}
                >
                  <SchemaIcon icon={icon} />
                </td>
              ))}
            </tr>
          ) : (
            (() => {
              const result = [];
              for (let i = 0, end = filteredIcons.length; i < end; i += 4) {
                result.push(
                  <tr key={`row-${i}`}>
                    {[0, 1, 2, 3].map((j) =>
                      i + j < filteredIcons.length ? (
                        <td
                          className="iconPicker-iconCell"
                          key={filteredIcons[i + j]}
                          onClick={this.iconChangeHandler.bind(this, filteredIcons[i + j])}
                        >
                          <SchemaIcon icon={filteredIcons[i + j]} />
                        </td>
                      ) : (
                        <td className="iconPicker-emptyCell" key={`empty-${i + j}`} />
                      )
                    )}
                  </tr>
                );
              }
              return result;
            })()
          )}
        </tbody>
      </table>
    );
  };

  override render(): JSX.Element {
    return (
      <div {...getTestProps({component: 'IconPicker', element: 'root'})}>
        <div
          aria-label="Edit"
          className={classNames('iconPicker-editButton u-tiny-spacing-top', {
            'is-active': this.state.isBeingEdited,
            'is-disabled': this.props.disabled,
          })}
          onClick={!this.props.disabled ? this._toggleOpen : undefined}
          role="button"
          tabIndex={0}
        >
          <div className="iconPicker-selectedIconWrapper">
            <SchemaIcon icon={this.props.value} />
          </div>
          {!this.props.disabled && <BenchlingIcon icon="edit" className="iconPicker-editIcon" />}
        </div>
        {this.state.isBeingEdited ? (
          <div className="iconPicker-dropdown">
            <div className="iconPicker-search">
              <input
                type="text"
                placeholder="Search icons..."
                value={this.state.searchQuery}
                onChange={this.handleSearchChange}
                autoFocus={true}
              />
            </div>
            {this.renderOptions()}
          </div>
        ) : undefined}
      </div>
    );
  }
}

export default IconPicker;
